package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class QuestionnaireDTO(
    val id: String,
    val name: String,
    val description: String? = null,
    val infoUrl: String? = null
)

@Serializable
data class QuestionnaireDetailDTO(
    val id: String,
    val name: String,
    val description: String? = null,
    val infoUrl: String? = null,
    val questions: List<QuestionnaireQuestionDTO> = emptyList()
)

@Serializable
data class QuestionnaireCreateRequest(
    val name: String,
    val description: String? = null,
    val infoUrl: String? = null
)

@Serializable
data class QuestionnaireUpdateRequest(
    val name: String? = null,
    val description: String? = null,
    val infoUrl: String? = null
)

@Serializable
data class QuestionnaireAttemptDTO(
    val attemptId: String,
    val questionnaireId: String,
    val name: String,
    val description: String? = null,
    val infoUrl: String? = null,
    val questions: List<QuestionnaireQuestionDTO> = emptyList(),
    val completed: Boolean = false
)

@Serializable
data class QuestionnaireQuestionDTO(
    val id: String,
    val text: String,
    val position: Int,
    val options: List<QuestionnaireOptionDTO> = emptyList(),
    val selectedOptionId: String? = null
)

@Serializable
data class QuestionnaireQuestionCreateRequest(
    val text: String,
    val position: Int,
    val options: List<QuestionnaireOptionCreateRequest> = emptyList()
)

@Serializable
data class QuestionnaireOptionDTO(
    val id: String,
    val text: String
)

@Serializable
data class QuestionnaireOptionCreateRequest(
    val text: String
)

@Serializable
data class SubmitQuestionnaireAnswerRequest(
    val questionId: String,
    val optionId: String
)
